module.exports = __webpack_public_path__ + "static/media/foto13.a7c426ef.jpg";